import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './firebase';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import BookPickupPage from './pages/BookPickupPage';
import TrackShipment from './pages/TrackShipment';
import AdminAccess from './pages/AdminAccess';
import AdminDashboard from './pages/AdminDashboard';
import AdminManagement from './pages/AdminManagement'; // ✅ Import new page
import { AppProvider } from './context/AppContext';
import { ToastProvider } from './context/ToastContext';
import ProtectedRoute from './components/ProtectedRoute';

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/book-pickup" element={<BookPickupPage />} />
      <Route path="/track" element={<TrackShipment />} />
      <Route path="/admin-login" element={<AdminAccess />} />
      <Route 
        path="/admin" 
        element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } 
      />
      {/* ✅ New route for admin management */}
      <Route 
        path="/admin/manage-users" 
        element={
          <ProtectedRoute>
            <AdminManagement />
          </ProtectedRoute>
        } 
      />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    console.log("📱 App Environment:", process.env.REACT_APP_USE_EMULATORS === 'true' ? 'Development' : 'Production');
    console.log("🌐 API URL:", process.env.REACT_APP_API_URL);
  }, []);

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
    >
    <AppProvider>
      <ToastProvider>
        <Router>
          <div className="flex flex-col min-h-screen">
            <Navbar />
            <main className="flex-grow">
              <AppRoutes />
            </main>
            <Footer />
          </div>
        </Router>
      </ToastProvider>
    </AppProvider>
    </GoogleReCaptchaProvider>
  );
}
export default App;